// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import * as config from '@/assets/js/config'
import 'babel-polyfill'
import Interceptors from '@/assets/js/interceptors'
import router from './router'
import ElementUI from 'element-ui'
import '@/assets/js/global'
import '@/directive/index.js'
import BaiduMap from 'vue-baidu-map'
import AMap from 'vue-amap'
window.config = Vue.prototype.config = config
// 自定义全局样式
import '@/assets/sass/index.scss'

//自定义全局组件
import PageContent from '@/components/page/page-content'
import MasterHeadPosition from '@/components/master/master-head-position'
import PagingDefault from '@/components/paging/paging-default'
import UploadFile from '@/components/upload/upload-file'
import UploadFilePdf from '@/components/upload/upload-file-pdf'
import UnitCode from '@/components/unitcode/unit-code'
import EnterpriseCode from '@/components/unitcode/enterprise-code'
import EntrustCode from '@/components/unitcode/entrust-code'
import ProjectName from '@/components/unitcode/project-name'
import carShip from '@/components/carship/car-ship-msg'
import mapLine from '@/components/map/map-line'
import amapLine from '@/components/map/amap-line'
import emapLine from '@/components/map/emap-line'
import waybillMap from '@/components/map/waybill-map'
import BackToTop from '@/components/master/to-top'
import Cascader from '@/components/cascader/index'
import pdf from 'vue-pdf'
Vue.prototype.pdfjsLib = pdfjsLib
Vue.prototype.pdfWorker = pdfjsWorker

//地图弧线
import { BmlCurveLine } from 'vue-baidu-map'
Vue.component('bml-curve-line', BmlCurveLine)
Vue.component('el-cascader', Cascader)
//导出运单为excel
import toExcel from '@/assets/js/file'
Vue.prototype.$toExcel = toExcel
Vue.prototype._isdisabled = true
//图片旋转
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer, {
  defaultOptions: {
    backdrop: 'static'
  }
})

//自定义指令-禁用空格
Vue.directive('disabledSpace', {
  inserted: function(el, binding) {
    el.addEventListener('keypress', function(e) {
      e = e || window.event
      if (e.code == 'Space') {
        e.preventDefault()
      }
    })
  }
})

// 这里是插件的默认设置
Viewer.setDefaults({
  zIndex: 9999,
  inline: false,
  button: true,
  navbar: true,
  title: false,
  toolbar: true,
  tooltip: true,
  movable: true,
  zoomable: true,
  rotatable: true,
  scalable: false,
  transition: true,
  fullscreen: false,
  keyboard: false
})

//
import global from '@/assets/js/common.js'
window.addEventListener('visibilitychange', function() {
  //这个方法是监测浏览器窗口发生变化的时候执行
  if (document.hidden == false && global.online != _global_.LOGIN_INFO.user_name) {
    if (global.online != null) {
      toUrl('/oauth/account-login')
    }
    global.online = _global_.LOGIN_INFO.user_name //只有当初始创建的online不等于localStorage里面的userId的时候去覆盖掉这个online
  }
})
//导出运输合同 PDF
import toPdf from '@/assets/js/topdf'
Vue.use(toPdf)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('page-content', PageContent)
Vue.component('master-head-position', MasterHeadPosition)
Vue.component('paging-default', PagingDefault)
Vue.component('upload-file', UploadFile)
Vue.component('upload-file-pdf', UploadFilePdf)
Vue.component('unit-code', UnitCode)
Vue.component('enterprise-code', EnterpriseCode)
Vue.component('entrust-code', EntrustCode)
Vue.component('project-name', ProjectName)
Vue.component('car-ship-msg', carShip)
Vue.component('map-line', mapLine)
Vue.component('amap-line', amapLine)
Vue.component('emap-line', emapLine)
Vue.component('waybill-map', waybillMap)
Vue.component('back-to-top', BackToTop)
Vue.component('pdf', pdf)

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'oPmwIbYEat0l3mtFHGNKVffqptoqhnAH'
})
Vue.filter('th', function(url) {
  let imageStyle = sessionStorage.getItem('imageStyle')
  return url.includes('static-5j56-com') ? url + '?x-oss-process=style/' + imageStyle : url
})
Vue.filter('toFixed', function(value, d) {
  if (value) {
    if (d) {
      return value.toFixed(d)
    }
    return value.toFixed(2)
  }
  return value
})
const Directives = {
  install(Vue) {
    Vue.directive('dbClick', {
      inserted(el, binding) {
        el.addEventListener('click', (e) => {
          if (!el.disabled) {
            el.disabled = true
            el.style.cursor = 'not-allowed'
            setTimeout(() => {
              el.style.cursor = 'pointer'
              el.disabled = false
            }, 1500)
          }
        })
      }
    })
  }
}
// Vue.use(VueQuillEditor);
Vue.use(Directives)
/* eslint-disable no-new */
Vue.use(AMap)
window._AMapSecurityConfig = {
  securityJsCode: 'de703b118efcbdd2c1390aa50eab3baf'
}
AMap.initAMapApiLoader({
  // key: '2dca18399337636f96b35e6a4a32687a',
  key: 'daf13afdd4a98a75355f19b245a5ba54',
  plugin: ['AMap.Autocomplete', 'AMap.Geolocation', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', ' AMap.GeometryUtil'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
  uiVersion: '1.0' //添加 uiVersion 的脚本版本号
})

new Vue({
  el: '#app',
  router,
  render: (h) => h(App),
  created() {
    if (_global_.UI) {
      Vue.prototype.GLOBAL = _global_
    } else {
      Vue.prototype.GLOBAL = {
        UI: {}
      }
    }
    //系统初始化
    let arr = []
    arr = window.location.href.split('?')
    let fix = arr[1]
    api('system.application.info', {
      domain_postfix: fix
    }).then((res) => {
      _global_.UI = res.data
      Vue.prototype.GLOBAL = _global_
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js